
  import {
    ComputedRef,
    PropType,
    computed,
    defineComponent,
    ref,
    onBeforeMount,
  } from 'vue'

  import WorkoutCard from '@/components/Workout/WorkoutCard.vue'
  import NoWorkouts from '@/components/Workouts/NoWorkouts.vue'
  import { WORKOUTS_STORE } from '@/store/constants'
  import { ISport } from '@/types/sports'
  import { IUserProfile } from '@/types/user'
  import { IWorkout } from '@/types/workouts'
  import { useStore } from '@/use/useStore'

  export default defineComponent({
    name: 'Timeline',
    components: {
      NoWorkouts,
      WorkoutCard,
    },
    props: {
      sports: {
        type: Object as PropType<ISport[]>,
        required: true,
      },
      user: {
        type: Object as PropType<IUserProfile>,
        required: true,
      },
    },
    setup(props) {
      const store = useStore()

      let page = ref(1)
      const per_page = 5
      const initWorkoutsCount =
        props.user.nb_workouts >= per_page ? per_page : props.user.nb_workouts
      onBeforeMount(() => loadWorkouts())

      const workouts: ComputedRef<IWorkout[]> = computed(
        () => store.getters[WORKOUTS_STORE.GETTERS.USER_WORKOUTS]
      )
      const moreWorkoutsExist: ComputedRef<boolean> = computed(() =>
        workouts.value.length > 0
          ? workouts.value[workouts.value.length - 1].previous_workout !== null
          : false
      )

      function loadWorkouts() {
        store.dispatch(WORKOUTS_STORE.ACTIONS.GET_USER_WORKOUTS, {
          page: page.value,
          per_page,
        })
      }
      function loadMoreWorkouts() {
        page.value += 1
        store.dispatch(WORKOUTS_STORE.ACTIONS.GET_MORE_USER_WORKOUTS, {
          page: page.value,
          per_page,
        })
      }

      return {
        initWorkoutsCount,
        moreWorkoutsExist,
        per_page,
        workouts,
        loadMoreWorkouts,
      }
    },
  })
